import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark site-nav px-4">
      <div className="container-fluid">
        <Link className="navbar-brand fw-bold" to="/">PROJECT <span className="text-danger">REDBOX</span></Link>
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link" href="/#demo">Play Demo</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#screenshots">Screenshots</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#devlogs">Devlogs</a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/worlds">Horizon Worlds</Link> {/* ✅ New */}
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/games">Games</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/minigrants">Minigrants</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
